import { lazy } from "react";

// route
export const indo5SORoute = { path: "/indo5_so", name: "indo5.menu.so", icon: "point_of_sale" };
export const indo5SOViewRoute = { path: `${indo5SORoute.path}/detail`, name: "indo5.so.detail" };

export const indo5DORoute = { path: "/indo5_do", name: "indo5.menu.do", icon: "view_list_icon" };
export const indo5DOViewRoute = { path: `${indo5DORoute.path}/detail`, name: "indo5.do.detail" };

export const indo5SalesRoute = { path: "/indo5_sales", name: "indo5.menu.sales", icon: "person" };
export const indo5SalesCreateRoute = { path: `${indo5SalesRoute.path}/create`, name: "indo5.sales.add" };
export const indo5SalesEditRoute = { path: `${indo5SalesRoute.path}/edit`, name: "indo5.sales.edit" };
export const indo5SalesConnectionRoute = { path: `${indo5SalesRoute.path}/connection`, name: "indo5.sales.connection" };

export const indo5DistributorRoute = { path: "/indo5_distributor", name: "indo5.menu.distributor", icon: "business_icon" };
export const indo5DistributorCreateRoute = { path: `${indo5DistributorRoute.path}/create`, name: "indo5.distributor.add" };
export const indo5DistributorEditRoute = { path: `${indo5DistributorRoute.path}/edit`, name: "indo5.distributor.edit" };

export const indo5CustomerRoute = { path: "/indo5_customer", name: "indo5.menu.customer", icon: "store" };
export const indo5CustomerCreateRoute = { path: `${indo5CustomerRoute.path}/create`, name: "indo5.customer.add" };
export const indo5CustomerEditRoute = { path: `${indo5CustomerRoute.path}/edit`, name: "indo5.customer.edit" };

export const indo5AssignmentRoutes = { path: "/assignment", name: "indo5.menu.assignment", icon: "assignment_icon" }
export const indo5AssignmentSalesRoutes = { path: `${indo5AssignmentRoutes.path}/sales`, name: "indo5.assignmentsales." }
export const indo5AssignmentSalesFormRoutes = { path: `${indo5AssignmentSalesRoutes.path}/list`, name: "indo5.assignmentsales.schedule" }
export const indo5AssignmentGoodsRoutes = { path: `${indo5AssignmentRoutes.path}/goods`, name: "indo5.assignmentgoods." }
export const indo5AssignmentGoodsFormRoutes = { path: `${indo5AssignmentGoodsRoutes.path}/list`, name: "indo5.assignmentgoods.list" }

export const indo5ProjectRoutes = { path: "/project", name: "indo5.menu.project", icon: "task" }
export const indo5ProjectListRoutes = { path: `${indo5ProjectRoutes.path}/list`, name: "indo5.menu.project_list" }
export const indo5ProjectCreateRoutes = { path: `${indo5ProjectListRoutes.path}/create`, name: "indo5.project_list.add" }
export const indo5ProjectEditRoutes = { path: `${indo5ProjectListRoutes.path}/edit`, name: "indo5.project_list.edit" }
export const indo5ProjectViewRoutes = { path: `${indo5ProjectListRoutes.path}/view`, name: "indo5.project_list.view" }

export const indo5ProjectDistListRoutes = { path: `${indo5ProjectListRoutes.path}/distributor_list`, name: "indo5.project_list.distributor" }
export const indo5ProjectDistAddRoutes = { path: `${indo5ProjectDistListRoutes.path}/add`, name: "indo5.project_list.add_distributor" }
export const indo5ProjectDistEditRoutes = { path: `${indo5ProjectDistListRoutes.path}/edit`, name: "indo5.project_list.edit_distributor" }

export const indo5ProjectSKUListRoutes = { path: `${indo5ProjectListRoutes.path}/sku_list`, name: "indo5.project_list.sku" }
export const indo5ProjectSalesListRoutes = { path: `${indo5ProjectListRoutes.path}/outlet_connection`, name: "indo5.project_list.customer" }
export const indo5ProjectSalesVisitUploadRoutes = { path: `${indo5ProjectListRoutes.path}/schedule_upload`, name: "indo5.project_list.sales_visit_upload" }
export const indo5ProjectSalesConnListRoutes = { path: `${indo5ProjectListRoutes.path}/schedule`, name: "indo5.project_list.sales_visit" }

export const indo5FormBuilderRoutes = { path: `${indo5ProjectRoutes.path}/form_builder`, name: "indo5.menu.form_builder" }
export const indo5FormBuilderCreateRoutes = { path: `${indo5FormBuilderRoutes.path}/create`, name: "indo5.form_builder.add" }
export const indo5FormBuilderEditRoutes = { path: `${indo5FormBuilderRoutes.path}/edit`, name: "indo5.form_builder.edit" }

// compomnent
const INDO5 = lazy(() => import("../page/indo5_dashboard/Indo5"));
const IDSO = lazy(() => import("../page/indo5_dashboard/so/Indo5SO"));
const IDSOView = lazy(() => import("../page/indo5_dashboard/so/view/Indo5SOView"));
const IDDO = lazy(() => import("../page/indo5_dashboard/do/Indo5DO"));
const IDDOView = lazy(() => import("../page/indo5_dashboard/do/view/Indo5DOView"));
const IDDistributor = lazy(() => import("../page/indo5_dashboard/distributor/Indo5Distributor"));
const IDDistributorForm = lazy(() => import("../page/indo5_dashboard/distributor/form/Indo5DistributorForm"));
const IDSales = lazy(() => import("../page/indo5_dashboard/sales/Indo5Sales"));
const IDSalesForm = lazy(() => import("../page/indo5_dashboard/sales/form/Indo5SalesForm"));
const IDSalesConnection = lazy(() => import("../page/indo5_dashboard/sales/outlet_connection/Indo5SalesOutlet"));
const IDCustomer = lazy(() => import("../page/indo5_dashboard/customer/indo5Customer"));
const IDCustomerForm = lazy(() => import("../page/indo5_dashboard/customer/form/Indo5CustomerForm"));
const IDAssignmentSales = lazy(() => import("../page/indo5_dashboard/assignment/indo5_sales/Indo5SalesAssignment"));
const IDAssignmentSalesForm = lazy(() => import("../page/indo5_dashboard/assignment/indo5_sales/form/Indo5SalesAssignmentForm"));
const IDAssignmentGoods = lazy(() => import("../page/indo5_dashboard/assignment/indo5_goods/Indo5GoodsAssignment"));
const IDAssignmentGoodsForm = lazy(() => import("../page/indo5_dashboard/assignment/indo5_goods/form/Indo5GoodsAssignmentForm"));
const IDProject = lazy(() => import("../page/indo5_dashboard/project/Indo5Project"));
const IDProjectForm = lazy(() => import("../page/indo5_dashboard/project/form/Indo5ProjectForm"));
const IDProjectView = lazy(() => import("../page/indo5_dashboard/project/Indo5ProjectDetail"));
const IDProjectDistList = lazy(() => import("../page/indo5_dashboard/project/distributor/Indo5ProjectDistributor"));
const IDProjectDistForm = lazy(() => import("../page/indo5_dashboard/project/distributor/form/Indo5ProjectDistributorForm"));
const IDProjectSKUList = lazy(() => import("../page/indo5_dashboard/project/sku/Indo5ProjectSKU"));
const IDProjectSalesList = lazy(() => import("../page/indo5_dashboard/project/sales/Indo5ProjectSales"));
const IDProjectSalesVisitUpload = lazy(() => import("../page/indo5_dashboard/project/sales/form_upload_visit/Indo5ProjectSalesVisitForm"));
const IDProjectSalesConnList = lazy(() => import("../page/indo5_dashboard/project/sales_connection/Indo5ProjectSalesConnection"));
const IDFormBuilder = lazy(() => import("../page/indo5_dashboard/form_builder/Indo5FormBuilder"));
const IDFormBuilderForm = lazy(() => import("../page/indo5_dashboard/form_builder/form/Indo5FormBuilderForm"));

export const indo5ListRoutes = [
    indo5SORoute, indo5DORoute, indo5DistributorRoute, indo5SalesRoute, indo5CustomerRoute,
    indo5AssignmentSalesRoutes, indo5AssignmentGoodsRoutes,
    indo5ProjectListRoutes, indo5FormBuilderRoutes
]
export const indo5AssignmentList = [indo5AssignmentSalesRoutes, indo5AssignmentGoodsRoutes]
export const indo5ProjectList = [indo5ProjectListRoutes, indo5FormBuilderRoutes]
export const indo5MutationRoutes = [
    indo5SOViewRoute, indo5DOViewRoute,
    indo5DistributorCreateRoute, indo5DistributorEditRoute,
    indo5SalesCreateRoute, indo5SalesEditRoute,
    indo5CustomerCreateRoute, indo5CustomerEditRoute,
    indo5AssignmentGoodsFormRoutes,
    indo5AssignmentSalesFormRoutes,
    indo5ProjectCreateRoutes, indo5ProjectEditRoutes, indo5ProjectViewRoutes,
    indo5ProjectDistListRoutes, indo5ProjectDistAddRoutes, indo5ProjectDistEditRoutes,
    indo5ProjectSKUListRoutes,
    indo5ProjectSalesListRoutes, indo5ProjectSalesConnListRoutes,
    indo5FormBuilderCreateRoutes, indo5FormBuilderEditRoutes,
    indo5SalesConnectionRoute, indo5ProjectSalesVisitUploadRoutes,
]

export const indo5Routes = [
    {
        element: <INDO5 />,
        children: [
            { ...indo5SORoute, element: <IDSO /> },
            { ...indo5SOViewRoute, element: <IDSOView /> },
            { ...indo5DORoute, element: <IDDO /> },
            { ...indo5DOViewRoute, element: <IDDOView /> },
            { ...indo5DistributorRoute, element: <IDDistributor /> },
            { ...indo5DistributorCreateRoute, element: <IDDistributorForm /> },
            { ...indo5DistributorEditRoute, element: <IDDistributorForm /> },
            { ...indo5SalesRoute, element: <IDSales /> },
            { ...indo5SalesCreateRoute, element: <IDSalesForm /> },
            { ...indo5SalesEditRoute, element: <IDSalesForm /> },
            { ...indo5SalesConnectionRoute, element: <IDSalesConnection /> },
            { ...indo5CustomerRoute, element: <IDCustomer /> },
            { ...indo5CustomerCreateRoute, element: <IDCustomerForm /> },
            { ...indo5CustomerEditRoute, element: <IDCustomerForm /> },
            { ...indo5AssignmentSalesRoutes, element: <IDAssignmentSales /> },
            { ...indo5AssignmentSalesFormRoutes, element: <IDAssignmentSalesForm /> },
            { ...indo5AssignmentGoodsRoutes, element: <IDAssignmentGoods /> },
            { ...indo5AssignmentGoodsFormRoutes, element: <IDAssignmentGoodsForm /> },
            { ...indo5ProjectListRoutes, element: <IDProject /> },
            { ...indo5ProjectViewRoutes, element: <IDProjectView /> },
            { ...indo5ProjectCreateRoutes, element: <IDProjectForm /> },
            { ...indo5ProjectEditRoutes, element: <IDProjectForm /> },
            { ...indo5ProjectDistListRoutes, element: <IDProjectDistList /> },
            { ...indo5ProjectDistAddRoutes, element: <IDProjectDistForm /> },
            { ...indo5ProjectDistEditRoutes, element: <IDProjectDistForm /> },
            { ...indo5ProjectSKUListRoutes, element: <IDProjectSKUList /> },
            { ...indo5ProjectSalesListRoutes, element: <IDProjectSalesList /> },
            { ...indo5ProjectSalesConnListRoutes, element: <IDProjectSalesConnList /> },
            { ...indo5ProjectSalesVisitUploadRoutes, element: <IDProjectSalesVisitUpload /> },
            { ...indo5FormBuilderRoutes, element: <IDFormBuilder /> },
            { ...indo5FormBuilderCreateRoutes, element: <IDFormBuilderForm /> },
            { ...indo5FormBuilderEditRoutes, element: <IDFormBuilderForm /> },
        ]
    }
]